import { MovieClipHelper } from './../../graphics/utils/MovieClipHelper';
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Container = createjs.Container;
/* TODO: @HTML5 Handle mouse@cursor classes
import Mouse = createjs.Mouse;
import MouseCursor = createjs.MouseCursor;
*/

export class BasicCustomCursor {
    public static CURSOR_ARROW: number = 1;
    public static CURSOR_CLICK: number = 2;
    public static CURSOR_DRAG: number = 3;
    public static CURSOR_HAND: number = 4;
    public static CURSOR_ZOOM: number = 5;

    public static MINIMUM_TIME_TO_UPDATE: number = 50;
    public static MAXIMUM_TIME_TO_FALLBACK: number = 150;

    private _lastUpdate: number = 0;
    private _lookForLowPerformance: boolean = false;
    private _useUpdateAfterEvent: boolean = true;

    private _disp: MovieClip;
    private _isEnabled: boolean = false;
    private _hidePermanent: boolean = false;
    private _additionalCursorGfx: Container;
    private _currentType: number;

    constructor(disp: MovieClip) {
        this._disp = disp;
        this._additionalCursorGfx = new Container();
        this._additionalCursorGfx.mouseChildren = false;
        this._additionalCursorGfx.mouseEnabled = false;
        this._disp.addChild(this._additionalCursorGfx);
    }

    public init(): void {
        // TODO: @HTML5 Handle mouse@cursor classes
        // Mouse.hide();
        this._disp.mouseEnabled = false;
        this._disp.mouseChildren = false;
        this._disp.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));
        this._isEnabled = true;
    }

    public onAddedToStage(e: Event): void {
        this._disp.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));
        this._disp.stage.addEventListener(MouseEvent.MOUSE_MOVE, this.bindFunction(this.updateMouse));
        this._disp.stage.addEventListener(MouseEvent.MOUSE_LEAVE, this.bindFunction(this.mouseLeaveHandler));
        this._disp.stage.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.updateTimer));
        this.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    };

    public hideForPerformance(): void {
        if (this._disp) {
            this._disp.stage.removeEventListener(MouseEvent.MOUSE_MOVE, this.bindFunction(this.updateMouse));
            this._disp.stage.removeEventListener(MouseEvent.MOUSE_LEAVE, this.bindFunction(this.mouseLeaveHandler));
            this._disp.stage.removeEventListener(MouseEvent.MOUSE_MOVE, this.bindFunction(this.mouseReturnHandler));
            this._disp.stage.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.updateTimer));
            this._disp.visible = false;
            this.isEnabled = false;
            this._hidePermanent = true;
        }
        /* TODO: @HTML5 Handle mouse@cursor classes
        Mouse.show();
        Mouse.cursor = MouseCursor.AUTO;
        */
    }

    private updateTimer(event: Event): void {
        this._lastUpdate = Date.now();

    };

    public setCursorType(type: number): void {
        if (this._currentType == type) {
            return;
        }

        if (this._disp) {
            MovieClipHelper.clearMovieClip(this.additionalCursorGfx);
            this._disp.gotoAndStop(type);
        }
    }

    /**
     * update Mouseposition
     */
    protected updateMouse(e: MouseEvent): void {
        if (!this._isEnabled) {
            return;
        }

        if (this._disp.stage) {
            this._disp.x = this._disp.stage.mouseX;
            this._disp.y = this._disp.stage.mouseY;

            if (this.isOkToUpdate()) {
                if (this._useUpdateAfterEvent) {
                    // TODO: @HTML5 updateAfterEvent not handled
                    // e.updateAfterEvent();
                }
            }
        }
    };

    private mouseLeaveHandler(e: Event): void {
        this.hideCustomCursor();
        // TODO: @HTML5 Handle mouse@cursor classes
        // Mouse.show();

        if (this._disp.stage) {
            this._disp.stage.addEventListener(MouseEvent.MOUSE_MOVE, this.bindFunction(this.mouseReturnHandler));
        }
    };

    private mouseReturnHandler(e: MouseEvent): void {
        /*showCustomCursor();
         Mouse.hide(); */
        this.isEnabled = this._isEnabled;

        if (this._disp.stage) {
            this._disp.stage.removeEventListener(MouseEvent.MOUSE_MOVE, this.bindFunction(this.mouseReturnHandler));
        }
    };

    public hideCustomCursor(): void {
        if (this._disp) {
            this._disp.visible = false;
        }
    }

    public showCustomCursor(): void {
        if (this._disp && !this._hidePermanent) {
            this._disp.visible = true;
        }
    }

    public set isEnabled(value: boolean) {
        this.setIsEnabled(value);
    }

    public setIsEnabled(value: boolean): void {
        if (this._hidePermanent) {
            return;
        }
        this._isEnabled = value;

        if (this._isEnabled) {
            // TODO: @HTML5 Handle mouse@cursor classes
            // Mouse.hide();
            this.showCustomCursor();
        }
        else {
            // TODO: @HTML5 Handle mouse@cursor classes
            // Mouse.show();
            this.hideCustomCursor();
            // TODO: @HTML5 Handle mouse@cursor classes
            // Mouse.cursor = MouseCursor.AUTO;
        }
    }

    public get isEnabled(): boolean {
        return this._isEnabled;
    }

    public get disp(): MovieClip {
        return this._disp;
    }

    public get additionalCursorGfx(): Container {
        return this._additionalCursorGfx;
    }

    private isOkToUpdate(): boolean {

        if (!this._lookForLowPerformance) {
            return true;
        }

        let now: number = Date.now();
        let updateTime: number = now - this._lastUpdate;

        if (updateTime > BasicCustomCursor.MAXIMUM_TIME_TO_FALLBACK) {

            this.hideForPerformance();
            return false;

        }

        if (updateTime > BasicCustomCursor.MINIMUM_TIME_TO_UPDATE) {
            this._lastUpdate = now;
            return true;
        }
        else {
            return false;
        }
    }

    public set lookForLowPerformance(value: boolean) {
        this._lookForLowPerformance = value;
        this._lastUpdate = Date.now();
    }

    public get useUpdateAfterEvent(): boolean {
        return this._useUpdateAfterEvent;
    }

    public set useUpdateAfterEvent(value: boolean) {
        this._useUpdateAfterEvent = value;
    }
}

